import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_MY_RESERVES_SAGA } from "../sagaTypes";
import { loadingAction, setMyReservesAction } from '../actions.js';
import { url } from "../../config";
import growl from "../../lib/growl/growl.js";

const request = data => {
    return fetch(`${ url }/get_my_res`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetMyReserves(args) {
    const user = yield select(state => state.user);

    yield put(loadingAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('user_hash', user.hash);

        const response = yield call (request, formData);

        if (response.success) {
            yield put(setMyReservesAction(response.data));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherGetMyReserves() {
    yield takeLatest(GET_MY_RESERVES_SAGA, workerGetMyReserves);
}